const pathTokenPattern = /[^.[\]]+/g;

function setAtPath(targetObject, path, value) {
    const tokens = typeof path === 'string' ? path.match(pathTokenPattern) : null;

    if (!targetObject || !tokens || tokens.length === 0) {
        return targetObject;
    }

    let cursor = targetObject;

    tokens.slice(0, -1).forEach((token, index) => {
        const nextToken = tokens[index + 1];
        const nextShouldBeArray = /^\d+$/.test(nextToken);
        const nextValue = cursor[token];

        if (!nextValue || typeof nextValue !== 'object') {
            cursor[token] = nextShouldBeArray ? [] : {};
        }

        cursor = cursor[token];
    });

    cursor[tokens[tokens.length - 1]] = value;
    return targetObject;
}

function getAtPath(sourceObject, path, defaultValue) {
    const tokens = typeof path === 'string' ? path.match(pathTokenPattern) : null;

    if (!tokens || tokens.length === 0) {
        return defaultValue;
    }

    let cursor = sourceObject;

    for (let i = 0; i < tokens.length; i += 1) {
        if (cursor == null) {
            return defaultValue;
        }
        cursor = cursor[tokens[i]];
    }

    return cursor === undefined ? defaultValue : cursor;
}

export default {
    setAtPath,
    getAtPath,
};
